import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/esim/EsimPage.tsx");
